import React from 'react';
import Label from '../FormElements/Label';
import TextInput from '../FormElements/TextInput';
import FormSection from '../FormElements/FormSection';
import FormSubmit from '../FormElements/FormSubmit';
import TextEditor from '../TextEditor/TextEditor';

export default class EditTemplateForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			templateName: ''
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {}

	componentDidUpdate(prevProps, prevState) {}

	render() {
		// console.log(
		// 	'Edit Template Form - Props',
		// 	this.props
		// 'Edit Template Form - State',
		// this.state
		// );
		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						<div className="my-3">
							<Label>{I18n.t('admin.template_name')}</Label>
							<TextInput
								placeholder={I18n.t('admin.template_name_placeholder')}
								name="templateName"
								value={this.state.templateName}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
					</FormSection>
				</form>
				<TextEditor
					endpoint={this.props.get_communication_template_endpoint}
					userTemplateRequest={this.props.userTemplateRequest}
					thingBeingCreated="template"
					onChange={this.onChange}
				/>
				
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {}
}
